import { Box, Divider, Drawer, drawerClasses, Grid, Stack } from '@mui/material'
import React from 'react'
import { ReactQueryDevtools } from 'react-query/devtools'

import { DrawerGremlinLogoLink } from 'components/navigation/Nav/DrawerGremlinLogoLink'
import { DrawerLinkToReleaseNotes } from 'components/navigation/Nav/DrawerLinkToReleaseNotes'
import { DrawerUserInfo } from 'components/navigation/Nav/DrawerUserInfo'
import { NavItemList } from 'components/navigation/Nav/NavItemList'
import { muiTheme } from 'mui-theme'
import { colors } from 'mui-theme/theme'
import theme from 'theme'
import { isPrivateEdition } from 'utils/app-config'
import { isDevelopmentEnvironment } from 'utils/environment'

const navBackgroundColor = colors.primary[900]
const dividerColor = colors.primary[200]

const sxNarrowDrawer = {
  width: 80,
  transition: 'width 1s'
}

const sxWideDrawer = {
  width: 210,
  transition: 'width 1s'
}

export const NavDrawer: React.FC<{
  userHasTeams: boolean
}> = ({ children, userHasTeams }) => {
  return (
    <Stack direction="row">
      <nav
        aria-label="main-navigation"
        css={{
          background: navBackgroundColor,
          zIndex: theme.zIndices[5]
        }}
      >
        <Drawer
          open
          id="NavDrawer"
          sx={{
            ...sxNarrowDrawer,
            flexShrink: 0,
            whiteSpace: 'normal',
            boxSizing: 'border-box',

            [muiTheme.breakpoints.up('md')]: sxWideDrawer,

            [`& .${drawerClasses.paper}`]: {
              ...sxNarrowDrawer,
              background: navBackgroundColor,
              overflowX: 'hidden',

              [muiTheme.breakpoints.up('md')]: sxWideDrawer
            }
          }}
          variant="permanent"
        >
          <Stack sx={{ flex: '1 1 auto' }}>
            <DrawerGremlinLogoLink url="/" />
            <NavItemList userHasTeams={userHasTeams} />
            {isDevelopmentEnvironment() &&
              !isPrivateEdition() &&
              !window.Cypress && <ReactQueryDevtools initialIsOpen={false} />}
            <Box
              sx={{
                display: 'none',
                [muiTheme.breakpoints.up('md')]: {
                  display: 'unset'
                }
              }}
            >
              <Divider sx={{ backgroundColor: dividerColor }} />
              <Grid
                container
                columnSpacing={1}
                rowSpacing={1}
                sx={{
                  color: muiTheme.palette.common.white,
                  padding: 3
                }}
              >
                <DrawerLinkToReleaseNotes />
                <DrawerUserInfo />
              </Grid>
            </Box>
          </Stack>
        </Drawer>
      </nav>
      {children}
    </Stack>
  )
}
